export enum BroadcastMessageType {
  CheckIfTheSessionIsTheSame,
  DropAdminSession,
  DropAllSessions,
}

export type CheckIfTheSessionIsTheSame = (portalAccessToken: string) => {
  type: BroadcastMessageType.CheckIfTheSessionIsTheSame;
  payload: string;
};

export type DropAdminSession = () => {
  type: BroadcastMessageType.DropAdminSession;
};

export type DropAllSessions = (dueToInactivity?: boolean) => {
  type: BroadcastMessageType.DropAllSessions;
  payload?: boolean;
};

export type BroadcastActions = CheckIfTheSessionIsTheSame | DropAdminSession | DropAllSessions;
